<template>
    <b-card no-body class="mb-0" >
        <div class="m-2">
            <b-row>
                <b-col
                    cols="12"
                    md="12"
                    class="mb-1 mb-md-0"
                >
                    <b-form @submit.prevent>
                        <b-row>

                        <b-col cols="12" md="6">
                            <!-- Société -->
                            <b-form-group
                            label="Société"
                            label-for="vi-fullSociete"
                            >
                                <b-input-group class="input-group-merge">
                                    <b-input-group-prepend is-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                    id="vi-fullSociete"
                                    v-model="datas.societe"
                                    placeholder="Société"
                                    required
                                    />
                                </b-input-group>
                            </b-form-group>

                            <b-form-group
                            label="Adresse1"
                            label-for="vi-fullAdresse1"
                            >
                                <b-input-group class="input-group-merge">
                                    <b-input-group-prepend is-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                    id="vi-fullAdresse1"
                                    v-model="datas.adresse1"
                                    placeholder="Adresse1"
                                    required
                                    />
                                </b-input-group>
                            </b-form-group>

                            <b-form-group
                            label="Adresse2"
                            label-for="vi-fullAdresse2"
                            >
                                <b-input-group class="input-group-merge">
                                    <b-input-group-prepend is-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                    id="vi-fullAdresse2"
                                    v-model="datas.adresse2"
                                    placeholder="Adresse2"
                                    />
                                </b-input-group>
                            </b-form-group>

                            <b-form-group
                            label="Adresse3"
                            label-for="vi-fullAdresse3"
                            >
                                <b-input-group class="input-group-merge">
                                    <b-input-group-prepend is-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                    id="vi-fullAdresse3"
                                    v-model="datas.adresse3"
                                    placeholder="Adresse3"
                                    />
                                </b-input-group>
                            </b-form-group>
                            <!-- Code postal -->
                            <b-form-group
                            label="Code postal"
                            label-for="vi-fullCodepostal"
                            >
                                <b-input-group class="input-group-merge">
                                    <b-input-group-prepend is-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                    id="vi-fullCodepostal"
                                    v-model="datas.codepostal"
                                    placeholder="Code postal"
                                    required
                                    />
                                </b-input-group>
                            </b-form-group>
                            <!-- Ville -->
                            <b-form-group
                            label="Ville"
                            label-for="vi-fullVille"
                            >
                                <b-input-group class="input-group-merge">
                                    <b-input-group-prepend is-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                    id="vi-fullVille"
                                    v-model="datas.ville"
                                    placeholder="Ville"
                                    required
                                    />
                                </b-input-group>
                            </b-form-group>
                            <!-- Pays -->
                            <b-form-group
                            label="Pays"
                            label-for="vi-fullPays"
                            >
                                <b-input-group class="input-group-merge">
                                    <b-input-group-prepend is-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                    id="vi-fullPays"
                                    v-model="datas.pays"
                                    placeholder="Pays"
                                    required
                                    />
                                </b-input-group>
                            </b-form-group>
                            <!-- Mentions légales -->
                            <b-form-group
                            label="Mentions légales"
                            label-for="vi-mentionsLegales"
                            >
                                <b-form-textarea
                                    id="vi-mentionsLegales"
                                    v-model="datas.mentions_legales"
                                    placeholder="Texte des mentions légales (SIRET, RCS, capital social, etc.)"
                                    rows="5"
                                    max-rows="12"
                                />
                            </b-form-group>

                        </b-col>

                        <b-col cols="12"  md="6">
                            <b-form-group
                            label="Logo société"
                            label-for="vi-logo"
                            description="PNG, JPG, GIF ou WebP. Affiché sur l’accueil et les factures."
                            >
                                <div
                                    v-if="logoPreviewSrc"
                                    class="mb-2 p-2 border rounded bg-light d-inline-block"
                                >
                                    <b-img
                                        :src="logoPreviewSrc"
                                        alt="Aperçu du logo"
                                        fluid
                                        thumbnail
                                        style="max-height: 140px; max-width: 100%;"
                                    />
                                </div>
                                <b-form-file
                                    id="vi-logo"
                                    v-model="logoFile"
                                    accept="image/png,image/jpeg,image/jpg,image/gif,image/webp"
                                    placeholder="Choisir une image…"
                                    browse-text="Parcourir"
                                    drop-placeholder="Déposer le fichier ici"
                                    @input="onLogoFileInput"
                                />
                            </b-form-group>

                            <b-form-group
                            label="Saison"
                            label-for="vi-fullSaison"
                            >
                                <b-form-select
                                    v-model="datas.saison"
                                    :options="datascategories"
                                />
                            </b-form-group>

                            <b-form-group
                            label="Devise"
                            label-for="vi-fullDevise"
                            >
                                <b-input-group class="input-group-merg mb-2">
                                    <b-input-group-prepend is-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                    id="vi-fullDevise"
                                    v-model="datas.devise"
                                    placeholder="€"
                                    required
                                    />
                                </b-input-group>
                            </b-form-group>

                            <b-form-group
                                label="Montant frais de port par paire"
                                label-for="vi-fullFraisPort"
                                >
                                <b-input-group class="input-group-merg mb-2">
                                    <b-input-group-prepend is-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                    id="vi-fullFraisPort"
                                    v-model="datas.fraisport"
                                    placeholder="0"
                                    />
                                </b-input-group>
                            </b-form-group>

                            <b-form-group
                                label="Montant frais de port"
                                label-for="vi-fullFraisPortMontant"
                                >
                                <b-input-group class="input-group-merg mb-2">
                                    <b-input-group-prepend is-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                    id="vi-fullFraisPortMontant"
                                    v-model="datas.fraisportmontant"
                                    placeholder="0"
                                    />
                                </b-input-group>
                            </b-form-group>

                            <b-form-group
                                label="Quantité pour franco de port"
                                label-for="vi-fullFranco"
                                >
                                <b-input-group class="input-group-merg mb-2">
                                    <b-input-group-prepend is-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                    id="vi-fullFranco"
                                    v-model="datas.franco"
                                    placeholder="0"
                                    required
                                    />
                                </b-input-group>
                            </b-form-group>

                            <b-form-group
                                label="Montant pour franco de port"
                                label-for="vi-fullFranco"
                                >
                                <b-input-group class="input-group-merg mb-2">
                                    <b-input-group-prepend is-text>
                                    </b-input-group-prepend>
                                    <b-form-input
                                    id="vi-fullmontantFranco"
                                    v-model="datas.francomontant"
                                    placeholder="0"
                                    required
                                    />
                                </b-input-group>
                            </b-form-group>

                            <b-form-group
                            label="Prix saisie en"
                            label-for="vi-fullPrix"
                            class="mb-4"
                            >
                                <b-form-radio-group class="demo-inline-spacing mb-2">
                                    <b-form-radio v-model="datas.typedeprix" :aria-describedby="ariaDescribedby" name="some-radios" value="HT">HT</b-form-radio>
                                    <b-form-radio v-model="datas.typedeprix" :aria-describedby="ariaDescribedby" name="some-radios" value="TTC">TTC</b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>

                            <!-- Filtre des clients par commerciaux -->
                            <b-form-group
                            label="Filtre des clients par commerciaux"
                            label-for="vi-filtreclient"
                            >
                                <b-form-checkbox
                                    v-model="datas.filtre_clients_par_commerciaux"
                                    value=true
                                    unchecked-value=false
                                    class="custom-control-primary mb-4"
                                >
                                    Activer
                                </b-form-checkbox>
                            </b-form-group>

                            <!-- Filtre des familles par commerciaux -->
                            <b-form-group
                            label="Filtre des familles par commerciaux"
                            label-for="vi-filtrefamille"
                            >
                                <b-form-checkbox
                                    v-model="datas.filtre_familles_par_commerciaux"
                                    value=true
                                    unchecked-value=false
                                    class="custom-control-primary mb-4"
                                >
                                    Activer
                                </b-form-checkbox>
                            </b-form-group>

                            <!-- Filtre des articles par commerciaux -->
                            <b-form-group
                            label="Filtre des articles par commerciaux"
                            label-for="vi-filtrearticle"
                            >
                                <b-form-checkbox
                                    v-model="datas.filtre_articles_par_commerciaux"
                                    value=true
                                    unchecked-value=false
                                    class="custom-control-primary mb-4"
                                >
                                    Activer
                                </b-form-checkbox>
                            </b-form-group>

                            <!-- Filtre des commandes par commerciaux -->
                            <b-form-group
                            label="Filtre des commandes par commerciaux"
                            label-for="vi-filtrcommande"
                            >
                                <b-form-checkbox
                                    v-model="datas.filtre_commandes_par_commerciaux"
                                    value=true
                                    unchecked-value=false
                                    class="custom-control-primary mb-4"
                                >
                                    Activer
                                </b-form-checkbox>
                            </b-form-group>
                        </b-col>

                        <!-- reset and submit -->
                        <b-col cols="12" class="mt-3">
                           <b-form-input
                                id="vi-id"
                                placeholder="ID"
                                v-model="datas.id"
                                hidden
                            />
                            <b-button
                            @click="submitForm()"
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            type="submit"
                            variant="primary"
                            class="mr-1">
                            Valider
                            </b-button>
                            <b-button
                                @click="$router.go(-1)"
                                variant="dark"
                                class="mr-1">
                                Retour
                            </b-button>
                        </b-col>
                        </b-row>
                    </b-form>
                </b-col>
        </b-row>
    </div>
</b-card>
</template>

<script>
import {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BInputGroup,
    BInputGroupPrepend,
    BLink,
    BCardHeader,
    BCardTitle,
    BTable,
    BAvatar,
    BFormFile,
    BFormRadioGroup,
    BFormRadio,
    BFormSelect,
    BFormTextarea,
    BInputGroupAppend,
    BImg,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import useJwt from '@/auth/jwt/useJwt'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PouchDB from 'pouchdb'
import moment from 'moment'

export default {
    components: {
        BCard,
        BRow,
        BCardHeader,
        BCardTitle,
        BTable,
        BCol,
        BFormGroup,
        BFormInput,
        BFormCheckbox,
        BInputGroup,
        BInputGroupPrepend,
        BForm,
        BButton,
        BLink,
        BAvatar,
        BFormSelect,
        BFormRadioGroup,
        BFormRadio,
        BInputGroupAppend,
        BFormFile,
        BFormTextarea,
        BImg,
    },
    mixins: [togglePasswordVisibility],

    directives: {
        Ripple,
    },
    data() {
        return {
            avatarText,
            previewImage:null,
            logoFile: null,
            logoPreviewDataUrl: '',
            pendingLogoDataUrl: null,
            logoAttachmentId: 'logo_societe',
            datas: [],
            datascategories: [],
            datasuser: [],
            test_password:"",
            file: null,
            role_options: [],
            selectedImage: '',
            localDB: new PouchDB(localStorage.getItem('database')),
            remoteDB: new PouchDB(localStorage.getItem('url')+'/'+localStorage.getItem('database')),
            remoteDBUser : '',
        };
    },
    computed: {
        logoPreviewSrc() {
            return this.pendingLogoDataUrl || this.logoPreviewDataUrl || null
        },
    },
    watch: {
        'datas.fraisport'(val) {
            if (val !== '' && val != null && this.datas.fraisportmontant !== '') {
                this.datas.fraisportmontant = ''
            }
        },
        'datas.fraisportmontant'(val) {
            if (val !== '' && val != null && this.datas.fraisport !== '') {
                this.datas.fraisport = ''
            }
        },
    },
    async created(){
        this.initialise()
    },
    methods: {
        findFirstImageAttachmentKey(attachments) {
            if (!attachments || typeof attachments !== 'object') return null
            for (const key of Object.keys(attachments)) {
                const meta = attachments[key]
                const ct = (meta && meta.content_type) || ''
                if (/^image\//i.test(ct)) return key
                if (/\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(key)) return key
            }
            return null
        },
        blobToDataUrl(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onloadend = () => resolve(reader.result)
                reader.onerror = reject
                reader.readAsDataURL(blob)
            })
        },
        onLogoFileInput(file) {
            const maxBytes = 5 * 1024 * 1024
            if (!file) {
                this.pendingLogoDataUrl = null
                return
            }
            if (file.size > maxBytes) {
                this.logoFile = null
                this.pendingLogoDataUrl = null
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Fichier trop volumineux',
                        icon: 'CoffeeIcon',
                        variant: 'danger',
                        text: 'Le logo ne doit pas dépasser 5 Mo.',
                    },
                })
                return
            }
            const reader = new FileReader()
            reader.onload = (e) => {
                this.pendingLogoDataUrl = e.target.result
            }
            reader.readAsDataURL(file)
        },
        async loadLogoPreviewFromDoc(doc) {
            this.logoPreviewDataUrl = ''
            this.pendingLogoDataUrl = null
            this.logoFile = null
            if (!doc || !doc._id || !doc._attachments) return
            const attKey = this.findFirstImageAttachmentKey(doc._attachments)
            if (!attKey) return
            try {
                const blob = await this.localDB.getAttachment(doc._id, attKey)
                this.logoPreviewDataUrl = await this.blobToDataUrl(blob)
            } catch (err) {
                console.warn('Aperçu logo setting', err)
            }
        },
        async removeAllImageAttachments(docId, rev) {
            let doc = await this.localDB.get(docId)
            let currentRev = rev || doc._rev
            if (!doc._attachments) return currentRev
            const keys = Object.keys(doc._attachments)
            for (const key of keys) {
                if (!this.findFirstImageAttachmentKey({ [key]: doc._attachments[key] })) continue
                await this.localDB.removeAttachment(docId, key, currentRev)
                doc = await this.localDB.get(docId)
                currentRev = doc._rev
            }
            return currentRev
        },
        async findSetting() {
            const resultSet = await this.localDB.find({ selector: { type: 'setting' } })
            if (resultSet.docs.length === 0) return
            const doc = resultSet.docs[0]
            const payload = { ...doc }
            const attKey = this.findFirstImageAttachmentKey(doc._attachments)
            if (attKey) {
                try {
                    const blob = await this.localDB.getAttachment(doc._id, attKey)
                    payload.imageBase64 = await this.blobToDataUrl(blob)
                } catch (err) {
                    console.warn('Erreur lecture pièce jointe setting', err)
                }
            }
            if (payload._attachments) delete payload._attachments
            localStorage.setting = JSON.stringify(payload)
        },
        async initialise() {
            // Lecture des document sur l'index de recherhe type=setting
            await this.localDB.find({selector: { type: 'setting'}}).then(async result => {
                console.log('setting', result.docs[0])
                this.datas = result.docs[0]
                if (this.datas.mentions_legales === undefined) {
                    this.$set(this.datas, 'mentions_legales', '')
                }
                await this.loadLogoPreviewFromDoc(this.datas)
            })
            await this.localDB.find({selector: { type: 'categoriesarticles'}}).then(result => {  
                this.datascategories.push({value: '', text: 'TOUTES'})
                result.docs.forEach((value, index) => {
                    this.datascategories.push({value: value.id, text: value.nom})
                })
                console.log('categoriesarticles', this.datascategories)
            })
        },
        async submitForm() {
            console.log('DATAS', this.datas)
            if(!this.datas.societe || !this.datas.adresse1 || !this.datas.codepostal || !this.datas.ville || !this.datas.pays || !this.datas.devise){
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Champs obligatoires',
                        icon: 'CoffeeIcon',
                        variant: 'danger',
                        text: 'Merci de renseigner les champs obligatoires',
                    },
                })
                return
            }
            this.datas.datemodif = moment().format('YYYY-MM-DDTHH:mm:ss')
            const docToSave = { ...this.datas }
            delete docToSave.imageBase64
            try {
                const current = await this.localDB.get(this.datas._id)
                docToSave._rev = current._rev
                if (this.logoFile) {
                    delete docToSave._attachments
                } else if (current._attachments) {
                    docToSave._attachments = current._attachments
                } else {
                    delete docToSave._attachments
                }
                const putRes = await this.localDB.put(docToSave)
                this.$set(this.datas, '_rev', putRes.rev)

                if (this.logoFile) {
                    let rev = await this.removeAllImageAttachments(this.datas._id, putRes.rev)
                    const mime = this.logoFile.type || 'image/png'
                    await this.localDB.putAttachment(
                        this.datas._id,
                        this.logoAttachmentId,
                        rev,
                        this.logoFile,
                        mime,
                    )
                    const updated = await this.localDB.get(this.datas._id)
                    this.$set(this.datas, '_rev', updated._rev)
                    this.logoFile = null
                    this.pendingLogoDataUrl = null
                    await this.loadLogoPreviewFromDoc(updated)
                }

                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Paramètres enregistrées',
                        icon: 'CoffeeIcon',
                        variant: 'success',
                        text: 'Vos paramètres ont été enregistrés',
                    },
                })
                await this.findSetting()

                await this.localDB.sync(this.remoteDB)
                    .on('complete', () => {
                        this.$router.push({ path: '/' })
                    })
                    .on('error', () => {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: 'Problème de synchronisation',
                                icon: 'CoffeeIcon',
                                variant: 'success',
                                text: 'Impossible de synchronisée la commande',
                            },
                        })
                        this.$router.push({ path: '/' })
                    })
            } catch (err) {
                console.log('errvalidation', err)
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Enregistrement impossible',
                        icon: 'CoffeeIcon',
                        variant: 'danger',
                        text: err && err.message ? err.message : 'Une erreur est survenue',
                    },
                })
            }
        },
    },
}
</script>
